import React from 'react';

const Loader = () => {
    const loadingAnimationClasses = 'animate-pulse transform scale-110';

    return (
        <div className="w-screen h-screen flex flex-col place-items-center items-center justify-center bg-white">

            <div className="flex flex-col items-center justify-center h-screen">
                <img
                    src={'/logo.png'}
                    alt="Logo"
                    className={`w-32 h-32 ${loadingAnimationClasses}`}
                />

                <h1 className='text-xl font-bold text-[#0a1a42] font-roboto'>Welcome To DRIC</h1>
            </div>

        </div>
    );
};

export default Loader;
